<div class="head-count">
  <div class="styled-container">
    <div class="row-container">
      <div class="col">
        <emerald-card>
          <div class="content-container">
            <div class="header-row">
              <div class="heading-title">{{ vendorProfile.contractorHeadCount }}</div>
              <div class="filter">
                <emerald-dropdown
                  [options]="monthOptions"
                  [outlined]="true"
                  [id]="'single_select'"
                  [label]="emeraldLabel.Month"
                  (onChange)="onMonthChange($event)"
                ></emerald-dropdown>
              </div>
            </div>
          </div>
          <!-- Check if contractorData is null -->
          <div *ngIf="!contractorData" class="metrics">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ metric.label }}</span>
              <span class="value">0</span>
            </div>
          </div>
          <!-- Display contractorData if available -->
          <div *ngIf="contractorData" class="metrics">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ metric.label }}</span>
              <span class="value">{{ metric.value || '0' }}</span>
            </div>
          </div>
        </emerald-card>
      </div>
    </div>
  </div>
</div>
